import React from "react";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const CTASection = ({ service }) => {
  const navigate = useNavigate();

  return (
    <section className="py-6 lg:py-8">
      <div className="max-w-[1700px] mx-auto px-6 sm:px-8 lg:px-10 xl:px-12">
        <motion.div
          initial={{ opacity: 0, y: 25 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.45 }}
          viewport={{ once: true }}
          className="relative overflow-hidden rounded-2xl"
        >
          {/* Background */}
          <div className="absolute inset-0 bg-gradient-to-r from-[#FF7A18] via-[#EC4899] to-[#8B5CF6]" />

          {/* Decorative Blobs */}
          <div className="absolute -top-20 -left-20 h-52 w-52 rounded-full bg-white/10 blur-3xl" />
          <div className="absolute -bottom-20 -right-20 h-56 w-56 rounded-full bg-white/10 blur-3xl" />

          {/* Content */}
          <div className="relative z-10 grid grid-cols-1 lg:grid-cols-2 items-center gap-8 px-6 py-8 sm:px-8 lg:px-10 lg:py-10">
            {/* Left Side */}
            <div>
              <span className="inline-flex items-center rounded-full bg-white/20 px-3 py-1.5 text-[11px] sm:text-xs font-semibold uppercase tracking-wider text-white">
                Ready To Get Started
              </span>

              <h2 className="mt-4 text-2xl sm:text-3xl lg:text-4xl font-bold leading-tight text-white">
                Build Your Next{" "}
                <span className="text-orange-100">
                  AI Solution
                </span>
              </h2>

              <p className="mt-4 max-w-2xl text-[15px] sm:text-base leading-7 text-white/90">
                Whether you need <strong>{service.title}</strong>, AI
                automation, intelligent chatbots, predictive analytics,
                enterprise AI platforms, or custom machine learning solutions,
                our experts are ready to transform your business with
                cutting-edge technology.
              </p>
            </div>

            {/* Right Side */}
            <div className="flex justify-start lg:justify-end ">
              <button
                onClick={() => navigate("/contact")}
                className="group inline-flex items-center gap-2 rounded-lg bg-white px-6 py-3 text-[15px] font-semibold text-[#EC4899] shadow-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-xl"
              >
               Book a free Consultation

                <ArrowRight
                  size={18}
                  className="transition-transform duration-300 group-hover:translate-x-1"
                />
              </button>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default CTASection;